import getConfig from 'next/config';

const { publicRuntimeConfig } = getConfig();

export const Authorization = publicRuntimeConfig.TOKEN_NAME;
